<template>
  <div
    class="form-group"
    v-bind="attrs"
    :id="dynamicId">
    <div
      v-if="label || extraLabel"
      class="d-flex justify-content-between align-items-center base-validation-label-row">
      <label v-if="label" class="mb-0">
        {{label}}
        <span
          v-if="/required/.test(JSON.stringify(validate))"
          class="text-danger">
          *
        </span>
      </label>
      <span
        v-if="extraLabel"
        class="base-validation-extra-label d-flex align-items-center"
        :style="accentColor ? { color: accentColor } : null">
        <i class="mdi mdi-information mr-1" aria-hidden="true" />
        {{ extraLabel }}
      </span>
    </div>
    <slot></slot>
    <small
      v-if="helper && !messageError"
      class="form-text d-block base-validation-helper"
      :style="accentColor ? { color: accentColor } : null">
      {{ helper }}
    </small>
    <!-- set obs description -->
    <small v-if="obs && !messageError" class="form-text text-primary text-right"><span>*</span>Obs: <span v-html="obs" /></small>
    <span
      class="invalid-feedback" :class="{'d-block': messageError}">
      <strong>{{messageError}}</strong>
    </span>
  </div>
</template>

<script>
export default {
  name: 'validationInput',
  inheritAttrs: false,
  data () {
    return {
      dynamicId: null,
      errors: []
    };
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    messageError: {
      type: String,
      default: null
    },
    fieldName: {
      type: String,
      default: null,
      description: 'Name your field to use in validation'
    },
    validate: {
      type: [String, Object],
      default: null,
      description: 'Validation rules'
    },
    obs: {
      type: String,
      default: null,
      description: 'Observation'
    },
    extraLabel: {
      type: String,
      default: ''
    },
    accentColor: {
      type: String,
      default: ''
    },
    helper: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: null,
      required: true,
      description: 'Id of input'
    }
  },
  computed: {
    attrs () {
      /* eslint-disable no-unused-vars */
      const {
        validate,
        messageError,
        fieldName,
        label,
        obs,
        extraLabel,
        accentColor,
        helper,
        id,
        name,
        placeholder,
        modelModifiers,
        rules,
        value,
        ...attrs
      } = this.$attrs;
      return attrs;
    }
  },
  methods: {
    generateDynamicId () {
      return Math.random().toString(36).substr(2, 9);
    },
  },
  beforeMount () {
    this.dynamicId = this.id + this.generateDynamicId();
  }
};
</script>

<style>
.base-validation-label-row {
  margin-bottom: 0.5rem;
}

.base-validation-extra-label {
  font-weight: 600;
  font-size: 12px;
  max-height: 14px;
}

.base-validation-helper {
  white-space: pre-line;
}
</style>
